import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/smartlift-logo-optimized.webp";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src={logo} 
            alt="SmartLift Garage Doors Logo" 
            className="w-12 h-12 object-contain" 
            width={48}
            height={48}
          />
          <span className="text-xl font-bold text-foreground hidden sm:inline">SmartLift Garage Doors</span>
        </Link>
        <div className="flex items-center gap-4">
          <Link to="/faqs" className="text-foreground hover:text-primary transition-colors font-medium hidden sm:inline">
            FAQs
          </Link>
          <Link to="/blog" className="text-foreground hover:text-primary transition-colors font-medium hidden sm:inline">
            Blog
          </Link>
          <Link to="/contact" className="text-foreground hover:text-primary transition-colors font-medium">
            Contact Us
          </Link>
          <Button variant="default" className="gap-2" asChild>
            <a href="tel:07836393815">
              <Phone className="w-4 h-4" />
              Call Now
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
